export default __webpack_public_path__ + "static/media/grafema_capitolio_12.0cbe334b.jpg";